// @flow
import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

import Button from 'app/components/commons/Button';
import FlexiSelect from 'app/components/commons/FlexiSelect';
import { LineupDisplayOrder } from 'app/scenes/fantasyInsider/constants';

const ButtonContainer = ({
  allLineUpsSaved,
  isSaving,
  isDownloading,
  selectedSortingOrder = LineupDisplayOrder.Default,
  onSelectLineupOrderChanged,
  onSaveAll,
  onDownloadLineUps,
  onClearLineUps
}: ButtonContainerProps) => (
  <ButtonsWrapper>
    <Button autoBorderRadius={false} onClick={onSaveAll} disabled={isSaving || allLineUpsSaved}>
      {allLineUpsSaved && (
        <FontAwesomeIcon icon={faCheckCircle} color="green" style={{ marginRight: 4 }} />
      )}
      MOVE ALL LINEUPS TO MY TEAMS
    </Button>
    <Button
      autoBorderRadius={false}
      kind="info"
      onClick={onDownloadLineUps}
      disabled={isDownloading}
    >
      EXPORT LINEUPS TO CSV
    </Button>
    <Button autoBorderRadius={false} kind="danger" onClick={onClearLineUps}>
      <FontAwesomeIcon icon={faTrashAlt} /> DELETE ALL LINEUPS
    </Button>
    <SortWrapper>
      <span>SORT LINEUPS</span>
      <StyledFlexiSelect
        onChange={value => {
          onSelectLineupOrderChanged(value);
        }}
        options={[
          { label: 'Default', value: LineupDisplayOrder.Default },
          { label: 'Projected High/Low', value: LineupDisplayOrder.ProjectedHighLow }
        ]}
        value={selectedSortingOrder}
      />
    </SortWrapper>
  </ButtonsWrapper>
);

export default ButtonContainer;

interface ButtonContainerProps {
  allLineUpsSaved: boolean;
  isSaving: boolean;
  isDownloading: boolean;
  selectedSortingOrder: number;
  onSelectLineupOrderChanged: () => void;
  onSaveAll: () => void;
  onDownloadLineUps: () => void;
  onClearLineUps: () => void;
}

const ButtonsWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  paddingBottom: theme.spacing.small
}));

const SortWrapper = styled.div(({ theme }) => ({
  marginTop: 10,
  padding: '0 10px',
  minHeight: '38px',
  [theme.mediaQuery.desktopLargeOnly]: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 0
  }
}));

const StyledFlexiSelect = styled(FlexiSelect)(() => ({
  display: 'inline-block',
  width: '150px',
  marginLeft: '5px'
}));
